var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-chat__content__body__greeting u-padding"},[_vm._m(0),_c('p',[_vm._v(_vm._s(_vm.$t("chat.content.notfound")))]),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('i',{staticClass:"icofont-robot"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-margin-top"},[_c('img',{attrs:{"src":require("@/assets/images/Logo.png"),"alt":""}})])
}]

export { render, staticRenderFns }